import { render, staticRenderFns } from "./excelOrderPay.vue?vue&type=template&id=70141b93&scoped=true&"
import script from "./excelOrderPay.vue?vue&type=script&lang=js&"
export * from "./excelOrderPay.vue?vue&type=script&lang=js&"
import style0 from "./excelOrderPay.vue?vue&type=style&index=0&id=70141b93&scoped=scoped&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70141b93",
  null
  
)

export default component.exports